module.exports = __webpack_public_path__ + "img/Appletsrcode.e046b4ae.png";